import React, { type ReactNode } from 'react';

export interface SourceStripProps {
  title: string;
  description?: string;
  badge?: string;
  annotation?: ReactNode;
}

/** A compact source header for the content below it. */
export function SourceStrip({ title, description, badge, annotation }: SourceStripProps) {
  return (
    <div className="rounded-t-md border-b border-gray-200 bg-gray-50 px-3 py-2">
      {annotation != null && <div className="mb-1 text-xs font-medium text-gray-400">{annotation}</div>}
      <div className="flex items-center gap-2 text-sm font-medium text-gray-700">
        {badge != null && badge !== '' && (
          <span aria-hidden="true" className="shrink-0 rounded bg-white px-1 text-xs leading-5 text-gray-500 ring-1 ring-inset ring-gray-200">
            {badge}
          </span>
        )}
        <span className="min-w-0 break-words">{title}</span>
      </div>
      {description != null && description !== '' && (
        <p className="mt-1 text-xs leading-4 text-gray-500">{description}</p>
      )}
    </div>
  );
}
